import apis from "../../api/api.actions";
import { parseQueryParams } from "../../api/parseParams";
let userpath = "v1/user";
let publicpath = "v1/common";
export const common_file_upload = (data) =>
  apis.createData(`${publicpath}/file/upload`, data).then((res) => res);

export const user_dash_list = (data) =>
  apis.getDatas(`${userpath}/user-dashboard`).then((res) => res);
export const user_deactivate = (id, data) =>
  apis.createData(`${userpath}/candidates/deactivate_req/${id}`, data).then((res) => res);
export const count_show = (data) =>
  apis.getDatas(`${publicpath}/count-show`).then((res) => res);

export const user_techprop_list = (data) =>
  apis
    .getDatas(
      `${publicpath}/technology-transfer/list-transfers${parseQueryParams(
        data
      )}`
    )
    .then((res) => res);
export const user_business_list = (data) =>
  apis.getDatas(`${userpath}/business-idea/list-proposal`).then((res) => res);
export const studentPropList = (data) =>
  apis.getDatas(`${publicpath}/student-proposals`).then((res) => res);

export const user_busprop_list = (data) =>
  apis.getDatas(`${userpath}/tenders`).then((res) => res);
// export const user_tenders_list = (data) =>
//   apis.getDatas(`${userpath}/tenders`).then((res) => res);
export const user_tenders_list = (data) =>
  apis.getDatas(`${publicpath}/tenders`).then((res) => res);

export const user_career_list = (data) =>
  apis.getDatas(`${publicpath}/career/list`).then((res) => res);
export const user_policies_list = (data) =>
  apis.getDatas(`${publicpath}/policy`).then((res) => res);
export const user_incentives_list = (data) =>
  apis.getDatas(`${publicpath}/incentive`).then((res) => res);
export const qualifications_list = () =>
  apis.getDatas(`${publicpath}/highest-qualification`).then((res) => res);
export const user_news_list = (data) =>
  apis.getDatas(`${publicpath}/newsupdate`).then((res) => res);
export const user_challenge_opportunity_list = (data) =>
  apis.getDatas(`${publicpath}/challenge-opportunity`).then((res) => res);
export const is_email_registered = (data) =>
  apis.createData(`email-exists`, data).then((res) => res);

export const user_company_users_list = (data) =>
  apis.getDatas(`${userpath}/company-users`).then((res) => res);

export const user_company_users_create = (data) =>
  apis.createData(`${userpath}/company-users`, data).then((res) => res);

export const user_company_users_update = (id, data) =>
  apis.updateData(`${userpath}/company-users/${id}`, data).then((res) => res);

export const user_company_users_delete = (id) =>
  apis.deleteData(`${userpath}/company-users/${id}`).then((res) => res);

export const user_event_booking = (data) =>
  apis.createData(`${publicpath}/event-booking`, data).then((res) => res);
export const user_create_company = (data) =>
  apis.createData(`${publicpath}/application-request`, data).then((res) => res);
export const user_company_domain_list = (data) =>
  apis.getDatas(`${publicpath}/domains-types`).then((res) => res);
export const update_company_registration = (id, data) =>
  apis.createData(`${userpath}/update-company/${id}`, data).then((res) => res);
export const update_resource_registration = (id, data) =>
  apis
    .createData(`${userpath}/resource-person/update/${id}`, data)
    .then((res) => res);
export const update_expert_registration = (id, data) =>
  apis
    .createData(`${userpath}/expert-man-power/update/${id}`, data)
    .then((res) => res);
export const update_academy_registration = (id, data) =>
  apis
    .createData(`${userpath}/institution/update/${id}`, data)
    .then((res) => res);
    export const update_vendor_registration = (id, data) =>
      apis
        .createData(`${publicpath}/vendors/update/${id}`, data)
        .then((res) => res);
    
export const tender_orgn_data = () =>
      apis.getDatas(`${publicpath}/tender-organisation`).then((res) => res);
export const tender_cate_data = () =>
  apis.getDatas(`${publicpath}/tender-category`).then((res) => res);
export const tender_org_data = () =>
  apis.getDatas(`${publicpath}/tender-organisation`).then((res) => res);
export const tender_cat_data = () =>
apis.getDatas(`${publicpath}/tender-category`).then((res) => res);
export const institution_data = () =>
  apis.getDatas(`${publicpath}/academic-institutions`).then((res) => res);
export const user_event_payment_booking = (id, data) =>
  apis
    .updateData(`${publicpath}/event-booking/update/${id}`, data)
    .then((res) => res);

export const user_company_details = (data) =>
  apis.getDatas(`${userpath}/company/${data}`).then((res) => res);
export const user_institutions_detail = (data) =>
  apis.getDatas(`${userpath}/institution/${data}`).then((res) => res);
export const user_vendor_detail = (data) =>
  apis.getDatas(`${publicpath}/vendors/showByuserId/${data}`).then((res) => res);

export const user_resource_detail = (data) =>
  apis.getDatas(`${userpath}/resource-person/view/${data}`).then((res) => res);

export const download_resource_person_file = (data) =>
  apis.getDatas(`${userpath}/resource-person/download/${data}`);
// export const download_resource_person_file = (data) =>
//   apis.getDatas(`${userpath}/resource-person/download/${data}`, {
//     responseType: "blob", // Ensures response is treated as a Blob (binary data)
//   }).then((res) => res);

export const download_expert_man_power_file = (data) =>
  apis.getDatas(`${userpath}/expert-man-power/download/${data}`);
export const download_student_proposal_file = (data) =>
  apis.getDatas(`${userpath}/proposal/download/${data}`);
export const download_intern_proposal_file = (data) =>
  apis.getDatas(`${userpath}/intern-proposal/download/${data}`);

export const user_expert_detail = (data) =>
  apis.getDatas(`${userpath}/expert-man-power/view/${data}`).then((res) => res);
export const user_area_types_list = (data) =>
  apis.getDatas(`${publicpath}/space-area-types`).then((res) => res);
export const user_locations_list = (data) =>
  apis.getDatas(`${publicpath}/locations`).then((res) => res);
// export const user_event_payment_booking = (id, data) =>
//   apis
//     .updateData(`${publicpath}/event-booking/update/${id}`, data)
//     .then((res) => res);
// export const get_faq_list = (id) =>
//   apis.getDatas(`${publicpath}/faq`).then((res) => res);

export const user_update_request = (data) =>
  apis.createData(`${userpath}/application-request`, data).then((res) => res);
export const user_new_request = (data) =>
  apis.createData(`${publicpath}/application-request`, data).then((res) => res);
export const create_company_request = (data) =>
  apis
    .createData(`${publicpath}/create-company`, data, {
      headers: { Authorization: "public" },
    })
    .then((res) => res);
export const create_accademic_institution = (data) =>
  apis
    .createData(`${publicpath}/create-institutions`, data, {
      headers: { Authorization: "public" },
    })
    .then((res) => res);
export const create_vendors = (data) =>
  apis
    .createData(`${publicpath}/vendors`, data, {
      headers: { Authorization: "public" },
    })
    .then((res) => res);
export const user_request = (data) =>
  apis.createData(`${publicpath}/application-request`, data).then((res) => res);
export const user_get_pplication = (data) =>
  apis.getDatas(`${userpath}/get-applications`).then((res) => res);
export const user_get_vendor_detail = (user_id) =>
  apis.getDatas(`${publicpath}/vendors/showByuserId/${user_id}`).then((res) => res);
export const user_get_candidates = (data) =>
  apis.getDatas(`${userpath}/get-applications`).then((res) => res);
export const user_company_list = (data, domain) =>
  apis
    .getDatas(`v1/common/companies${parseQueryParams(data)}${domain}`)
    .then((res) => res);
export const user_company_list_new = (data, domain) =>
  apis
    .getDatas(`v1/common/companies/kerala${parseQueryParams(data)}`)
    .then((res) => res);
export const kspace_company_list = (data, domain) =>
  apis
    .getDatas(`v1/common/application-request-list${parseQueryParams(data)}`)
    .then((res) => res);
export const kspace_company_completed_list = (data, domain) =>
  apis
    .getDatas(`v1/common/application-request-list-completed${parseQueryParams(data)}`)
    .then((res) => res);
export const kspace_company_own_completed_list = (data, domain) =>
  apis
    .getDatas(`v1/common/companies/own_premises_completed${parseQueryParams(data)}`)
    .then((res) => res);
export const kspace_own_company_list = (data, domain) =>
  apis
    .getDatas(`v1/common/application-request-own${parseQueryParams(data)}`)
    .then((res) => res);
export const kspace_company_own_list = (data, domain) =>
  apis
    .getDatas(`v1/common/companies/own_premises${parseQueryParams(data)}`)
    .then((res) => res);

export const user_company_list_kspace = (data) =>
  apis
    .getDatas(`${publicpath}/companies${parseQueryParams(data)}`)
    .then((res) => res);
export const user_company_list_kerala = (status) =>
  apis
    .getDatas(`${status ? userpath : publicpath}/directory-kerala`)
    .then((res) => res);
export const user_company_list_india = (status) =>
  apis
    .getDatas(`${status ? userpath : publicpath}/directory-india`)
    .then((res) => res);
export const userAreaList = (status) =>
  apis
    .getDatas(`${status ? userpath : publicpath}/areas`)
    .then((res) => res);
export const user_company_list_international = (status) =>
  apis
    .getDatas(`${status ? userpath : publicpath}/directory-international`)
    .then((res) => res);
export const get_company_domain_list = (status) =>
  apis
    .getDatas(`${status ? publicpath : publicpath}/domains-types`)
    .then((res) => res);

export const user_company_list_kspace_search = (status, data) =>
  apis
    .createData(`${status ? userpath : publicpath}/search-keyword-kspace`, data)
    .then((res) => res);
export const user_company_list_kerala_search = (status, data) =>
  apis
    .createData(`${status ? userpath : publicpath}/search-keyword-kerala`, data)
    .then((res) => res);
export const user_company_list_india_search = (status, data) =>
  apis
    .createData(`${status ? userpath : publicpath}/search-keyword-india`, data)
    .then((res) => res);
export const user_company_list_international_search = (status, data) =>
  apis
    .createData(
      `${status ? userpath : publicpath}/search-keyword-international`,
      data
    )
    .then((res) => res);
export const user_company_list_kspace_filter = (status, data) =>
  apis
    .createData(`${status ? userpath : publicpath}/domain-filter-kspace`, data)
    .then((res) => res);
export const user_company_list_kerala_filter = (status, data) =>
  apis
    .createData(`${status ? userpath : publicpath}/domain-filter-kerala`, data)
    .then((res) => res);
export const user_company_list_india_filter = (status, data) =>
  apis
    .createData(`${status ? userpath : publicpath}/domain-filter-india`, data)
    .then((res) => res);
export const user_company_list_international_filter = (status, data) =>
  apis
    .createData(
      `${status ? userpath : publicpath}/domain-filter-international`,
      data
    )
    .then((res) => res);
export const user_create_proposal = (data) =>
  apis
    .createData(`${publicpath}/business-idea/project-proposal`, data)
    .then((res) => res);
export const user_create_techproposal = (data) =>
  apis
    .createData(`${publicpath}/technology-transfer/create`, data)
    .then((res) => res);

export const expertManPowerCreateLookup = (data) =>
  apis.getDatas(`${publicpath}/expert-man-power/look-up`).then((res) => res);

export const expertManPowerCreate = (data) =>
  apis
    .createData(`${publicpath}/expert-man-power/create`, data, {
      headers: { Authorization: "public" },
    })
    .then((res) => res);
export const candidaterCreate = (data) =>
  apis
    .createData(`${publicpath}/candidate`, data, {
      headers: { Authorization: "public" },
    })
    .then((res) => res);
export const expertManPowerList = (data) =>
  apis.getDatas(`${publicpath}/expert-man-power/list`, data).then((res) => res);
export const candidateList = (data) =>
  apis
    .getDatas(`${userpath}/candidate${parseQueryParams(data)}`, data)
    .then((res) => res);
export const candidateDownloadedList = (data) =>
  apis.getDatas(`${userpath}/candidates/profiles`, data).then((res) => res);
export const candidate_download = (data) =>
  apis.createData(`${userpath}/candidate/download`, data).then((res) => res);
export const pdf_download = (id) =>
  apis.getDatas(`${userpath}/candidates/pdfdownload/${id}`).then((res) => res);
export const resourcePersonalList = (data) =>
  apis.getDatas(`${publicpath}/resource-person/list`, data).then((res) => res);

export const user_get_manpower_details = (id) =>
  apis.getDatas(`${userpath}/expert-man-power/view/${id}`).then((res) => res);
export const user_get_advisor_details = (id) =>
  apis.getDatas(`${userpath}/view/space-park-advisor/${id}`).then((res) => res);
export const user_get_candidatereg_details = (id, data) =>
  apis
    .createData(`${publicpath}/candidate-update/${id}`, data)
    .then((res) => res);
export const user_get_candidate_details = (id) =>
  apis.getDatas(`${userpath}/candidate/${id}`).then((res) => res);
export const user_get_downloaded_candidate_details = (id) =>
  apis.getDatas(`${userpath}/candidates/profiles/${id}`).then((res) => res);
export const interview_candidate_details = (id) =>
  apis
    .createData(`${userpath}/candidates/profiles/interview/${id}`)
    .then((res) => res);
export const job_confirm = (id, data) =>
  apis
    .createData(`${userpath}/candidates/profiles/appointment/${id}`, data)
    .then((res) => res);
export const job_joined = (id, data) =>
  apis
    .createData(`${userpath}/candidates/profiles/offer/${id}`, data)
    .then((res) => res);
export const job_payment = (id, data) =>
  apis
    .createData(`${userpath}/candidates/profiles/confirmation/${id}`, data)
    .then((res) => res);

export const resourcePersonalCreate = (data) =>
  apis
    .createData(`${publicpath}/resource-person/create`, data, {
      headers: { Authorization: "public" },
    })
    .then((res) => res);

export const get_faq_list = (id) =>
  apis.getDatas(`${publicpath}/faq`).then((res) => res);

export const resPerList = (data) =>
  apis.getDatas(`${userpath}/expert-man-power/list`, data).then((res) => res);

export const user_res_per_details = (id) =>
  apis.getDatas(`${userpath}/expert-man-power/view/${id}`).then((res) => res);

export const institutionList = () =>
  apis.getDatas(`${publicpath}/institutions`).then((res) => res);
export const vendorDirectoryList = (search) =>
  apis.getDatas(`${publicpath}/vendor-approved?search=${search}`).then((res) => res);

export const studentPropCreate = (data) =>
  apis
    .createData(`${publicpath}/stud-proposal/create`, data)
    .then((res) => res);

export const studentInternCreate = (data) =>
  apis.createData(`${publicpath}/internship-apply`, data).then((res) => res);

export const inter_list = () =>
  apis.getDatas(`${userpath}/internship-proposals`).then((res) => res);
export const inter_details = (id) =>
  apis.getDatas(`${userpath}/intern-proposal/${id}`).then((res) => res);

export const userPublications = () =>
  apis.getDatas(`${publicpath}/publications`).then((res) => res);

export const get_user_resourse_details = (id) =>
  apis.getDatas(`${userpath}/resource-person/view/${id}`).then((res) => res);

// Application Financial Records
// POST /api/v1/user/applications/{id}/financial-years
export const add_financial_record = (applicationId, data) =>
  apis
    .createData(`${userpath}/applications/${applicationId}/financial-years`, data)
    .then((res) => res);

// PUT /api/v1/admin/applications/{id}/financial-years/{year}
export const update_financial_record = (applicationId, financialYear, data) =>
  apis
    .updateData(
      `${userpath}/applications/${applicationId}/financial-years/${encodeURIComponent(
        financialYear
      )}`,
      data
    )
    .then((res) => res);

// POST /api/v1/user/applications/{id}/logo
export const upload_application_logo = (applicationId, formData) =>
  apis.createData(`${userpath}/applications/${applicationId}/logo`, formData).then((res) => res);

export const upload_company_logo = (applicationId, formData) =>
  apis.createData(`${userpath}/company/${applicationId}/logo`, formData).then((res) => res);

// Internship APIs
export const internshipRequestsList = (data) =>
  apis
    .getDatas(`${userpath}/internship-requests`, data)
    .then((res) => res);

export const submitInternshipProposal = (data) =>
  apis
    .createData(`${userpath}/internship-requests`, data)
    .then((res) => res);

export const internshipQualifications = () =>
  apis
    .getDatas(`${publicpath}/internship-qualifications`)
    .then((res) => res);

export const internshipRequestDetail = (id) =>
  apis
    .getDatas(`${userpath}/internship-requests/${id}`)
    .then((res) => res);

export const updateInternshipProposal = (id, data) =>
  apis
    .updateData(`${userpath}/internship-requests/${id}`, data)
    .then((res) => res);

export const getInternshipRankings = (id) =>
  apis
    .getDatas(`${userpath}/internship-requests/${id}/rankings`)
    .then((res) => res);

export const selectInternshipApplicant = (proposalId, applicantId) =>
  apis
    .createData(`${userpath}/internship-proposals/${proposalId}/select`, { applicant_id: applicantId })
    .then((res) => res);

export const evaluateInternshipProposal = (proposalId, formData) =>
  apis
    .createData(`${userpath}/internship-proposals/${proposalId}/evaluate`, formData)
    .then((res) => res);

export const myInternshipsList = () =>
  apis.getDatas(`${userpath}/my-internships`).then((res) => res);

export const myInternshipDetail = (id) =>
  apis.getDatas(`${userpath}/my-internships/${id}`).then((res) => res);

export const studentProfileDetail = () =>
  apis.getDatas(`${userpath}/student-profile`).then((res) => res);